import React, { Component } from 'react';
import { CUSTOMIZE_AGGREGATE } from '@/util/enums/EnumLayers';
import {
  ModalCustomizeAggregate,
  ModalCustomizeAggregateProps,
} from '@/features/countIf/ModalCustomizeAggregate/ModalCustomizeAggregate';

// eslint-disable-next-line camelcase
class ModalCustomizeAggregate_WITH_DEPRICATED_STATIC_METHODS extends Component<ModalCustomizeAggregateProps> {
  static modalType() {
    return CUSTOMIZE_AGGREGATE;
  }

  static reducer(modals: any) {
    return modals.modalCustomizeAggregateReducer;
  }

  static title() {
    return 'Customize metric';
  }

  static subTitle() {
    return null;
  }

  render() {
    return <ModalCustomizeAggregate {...this.props} />;
  }
}

// eslint-disable-next-line camelcase
export default ModalCustomizeAggregate_WITH_DEPRICATED_STATIC_METHODS;
